import ClientOrgChart from './ClientOrgChart';

export default ClientOrgChart;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/actorsHandler/clientOrgChart/index.js